<template>
	<h5><span class="prefix">Element and context:</span> {{ elementType }} in {{ contextItemTitle }}</h5>
</template>

<script>
import PlacementService from '@/utils/placement-service';

export default {
	name: 'ContextHeader',
	props: { placement: { type: Object }, elementType: { type: String } },
	computed: {
		contextItemTitle() {
			return PlacementService.getFullItemName(this.placement);
		},
	},
};
</script>

<style lang="scss" scoped>
.prefix {
	opacity: 0.5;
}
</style>
